import bodyScrollLock from "body-scroll-lock";

let wrapper = document.querySelector('.mobile__nav');

export function navigationMobile() {
    const bodyScrollLock = require('body-scroll-lock');
    let btn = document.querySelector('.btn__mobile-menu');

    if (!btn || !wrapper) {
        return;
    }

    btn.addEventListener('click', function (){
        wrapper.classList.toggle('show');

        if(wrapper.classList.contains('show')){
            bodyScrollLock.disableBodyScroll(wrapper)
        }else{
            bodyScrollLock.enableBodyScroll(wrapper)
        }
    })
}

export function navigationHasChildren() {
    if (!wrapper) {
        return;
    }

    let menu_with_children = wrapper.querySelectorAll('.menu-item-has-children');

    menu_with_children.forEach((item) => {

        const btn = document.createElement('input');
        const label = document.createElement('label')
        let btn_id = btoa(Math.random()).slice(0, 5);
        btn.setAttribute('type', 'checkbox')
        btn.setAttribute('class', 'dropdown')
        btn.setAttribute('id', btn_id);
        label.setAttribute('for', btn_id)
        label.appendChild(document.createTextNode('dropdown'))
        let placement = item.querySelector('a');

        placement.after(btn, label);
    });
}

export function navigationMobileClick() {
    if (!wrapper) {
        return;
    }

    var links = document.querySelectorAll('li');

    links.forEach((link) => {
        link.addEventListener('click', function () {
            if(link.classList.contains('menu-item-has-children')){
                this.querySelector('label').click();
            }else{
                this.querySelector('a').click();
            }

        })
    })


}